import { useCallback, useState } from "react";
import type { PaginationState, Updater } from "@tanstack/react-table";

type PaginationUpdater = Updater<PaginationState>;

export const usePagination = (initialPageSize = 10) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: initialPageSize,
  });

  const setPageIndex = useCallback((pageIndex: number) => {
    setPagination((prev) =>
      prev.pageIndex === pageIndex ? prev : { ...prev, pageIndex },
    );
  }, []);

  const setPageSize = useCallback((pageSize: number) => {
    setPagination((prev) =>
      prev.pageSize === pageSize ? prev : { ...prev, pageSize },
    );
  }, []);

  const onPaginationChange = useCallback((updater: PaginationUpdater) => {
    setPagination((prev) => {
      const newPageIndex =
        typeof updater === "function"
          ? updater(prev).pageIndex
          : updater.pageIndex;
      return prev.pageIndex === newPageIndex
        ? prev
        : { ...prev, pageIndex: newPageIndex };
    });
  }, []);

  return {
    pagination,
    setPageIndex,
    setPageSize,
    onPaginationChange,
  };
};
